module.exports = __webpack_public_path__ + "img/icon-supplier-conversations-normal.6eee0c60.svg";